import SitePage from 'src/app/pages/SitePage';
import { Server } from './server';
import { Service, ServiceResponse } from './service';
import { sendDeviceNotification } from 'src/app/util/notifications';

export class MonitorService extends Service {
  protected state: any = null;

  public async init(): Promise<ServiceResponse> {
    this.initState();

    Server.network.addEventListener('chat-message', (event:any)=>{this.onNetworkChatMessage(event)});
    Server.network.addEventListener('chat-started', (event:any)=>{this.onNetworkChatStarted(event)});

    return {success: true};
  }

  protected initState() {
    this.state = {
      lastTime: 0,
      interval: null,
      checking: false,
      lastFocus: document.hasFocus(),
      chatsCounter: 0,
      counter: 0,
      lastContent: {
        activity: null,
        notifications: null,
        chats: {},
      },
      lastRead: {
        activity: null,
        notifications: null,
        chats: {},
      }
    };
  }

  public start() {
    this.initState();

    this.state.lastRead.activity = Server.user.getCookie('ActivityLastRead');
    this.state.lastRead.notifications = Server.user.getCookie('NotificationsLastRead');

    let chats = Server.user.getChats();
    for(let i = 0; i < chats.length; i++) {
      let chat = chats[i];
      this.state.lastRead.chats[chat.id] = Server.user.getCookie('ChatLastRead-' + chat.id);
    }

    this.state.interval = setInterval(() => {
      this.checkForNewContent();
    }, 1000);
  }

  public stop() {
    if(!this.state)
        return;

    if(this.state.interval)
      clearInterval(this.state.interval);

    this.state = null;
  }

  protected async checkForNewContent() {
    if(!Server.isLoggedIn() || SitePage.isShutdown || !Service.community) {
      this.state.lastTime = 0;
      return;
    }

    if(this.state.checking)
      return;

    let now = performance.now();

    if(this.state.lastTime > 0) {
      let elapsed = now - this.state.lastTime;
      if(elapsed < (60 * 1000))
        return;
    }

    this.state.checking = true;

    if(document.hasFocus() != this.state.lastFocus) 
      this.state.chatsCounter = 0;
    
    this.state.lastFocus = document.hasFocus();

    if(!Server.network.isConnected()) {
      // let duration = 0;
      // if (this.monitor.chatsCounter === 0) 
      //   duration = 0;            
      // else if (this.monitor.chatsCounter % 30 === 0) 
      //   duration = 60;           
      // else if (this.monitor.chatsCounter % 15 === 0) 
      //   duration = 30;           
      // else if (this.monitor.chatsCounter % 5 === 0) 
      //   duration = 15;            
      // else 
      //   duration = 5;            
      
      let direct = this.state.chatsCounter % 2 == 0;
      let duration = this.state.chatsCounter % 2 == 0 ? 0 : 60;
      await this.checkForNewChats(direct, duration);

      this.state.chatsCounter = (this.state.chatsCounter + 1) % 60;
    }
    else 
      this.state.chatsCounter = 0;


    let checkNewContent = document.hasFocus() ? true : (this.state.counter % 2 == 0);
    if(checkNewContent) {
      await this.checkForNewNotifications();
      await this.checkForNewActivityPosts();
    }

    this.state.checking = false;
    this.state.lastTime = now;
    this.state.counter++;
  }

  public isCheckingForNewContent() {
    return this.state.checking;
  }

  // notifications monitoring
  protected async checkForNewNotifications() {
    if(window.location.hostname.includes('localhost'))
      console.log('checkForNewNotifications', new Date().toLocaleTimeString());

    let response = await Server.user.getLatestNotificationDate();
    if(!response.success)
      return;

    let lastReadCookie = Server.user.getCookie('NotificationsLastRead');

    if(response.date != this.state.lastContent.notifications) {
      window.sessionStorage.removeItem(`NotificationsRefresh`);
      if(response.date != this.state.lastRead.notifications) 
        sendDeviceNotification('There are new notifications!', 'DeviceNotificationsNotifications')
    }

    this.state.lastContent.notifications = response.date;
    this.state.lastRead.notifications = lastReadCookie;
  }

  public async setNotificationsLastRead(date: string, force: boolean = false) {
    let lastReadCookie = Server.user.getCookie('NotificationsLastRead');
    if(lastReadCookie && date <= lastReadCookie && !force) 
      return;
    await Server.user.setCookie({key: 'NotificationsLastRead', value: date});
    this.state.lastRead.notifications = date;
  }

  public getNotificationsLastRead() {
    return this.state ? this.state.lastRead.notifications : null;
  }

  public isNewNotifications(date:string = null) {
    if(!this.state)
      return false;

    if(!this.state.lastContent.notifications)
      return false;

    if(!this.state.lastRead.notifications || !this.state.lastContent.notifications)
      return false;

    if(!date)
      date = this.state.lastContent.notifications;

    return date > this.state.lastRead.notifications;
  }

  // activity monitoring
  protected async checkForNewActivityPosts() {
    if(window.location.hostname.includes('localhost'))
      console.log('checkForNewActivityPosts', new Date().toLocaleTimeString());

    let response = await Server.activity.getLatestPostDate();
    if(!response.success)
      return;

    let lastReadCookie = Server.user.getCookie('ActivityLastRead');

    if(response.date != this.state.lastContent.activity) {
      window.sessionStorage.removeItem(`ActivityPostsRefresh`);

      if(response.date != this.state.lastRead.activity) 
        sendDeviceNotification('There are new activity posts!', 'DeviceNotificationsActivity');
    }

    this.state.lastContent.activity = response.date;
    this.state.lastRead.activity = lastReadCookie;
  }

  public async setActivityLastRead(date: string, force: boolean = false) {
    let lastReadCookie = Server.user.getCookie('ActivityLastRead');
    if(lastReadCookie && date <= lastReadCookie && !force)
      return;
    await Server.user.setCookie({key: 'ActivityLastRead', value: date});
    this.state.lastRead.activity = date;
  }

  public getActivityLastRead() {
    return this.state ? this.state.lastRead.activity : null;
  }

  public isNewActivity(date:string = null) {
    if(!this.state)
      return false;

    if(!this.state.lastContent.activity)
      return false;

    if(!this.state.lastRead.activity || !this.state.lastContent.activity)
      return false;

    if(!date)
      date = this.state.lastContent.activity;

    return date > this.state.lastRead.activity;
  }

  // chat monitoring
  public async checkForNewChats(direct:boolean, duration: number) {
    if(window.location.hostname.includes('localhost'))
      console.log('checkForNewChats', direct, duration, new Date().toLocaleTimeString());

    let userChats = Server.user.getChats();

    let currentTime = new Date().getTime();
    let params:any = {direct, group: true};

    if(duration > 0) {
      let groupIds = [];
      for(let i = 0; i < userChats.length; i++) {
        if(userChats[i].type != 'group')
          continue;
  
        let date = this.state.lastContent.chats[userChats[i].id];
  
        if (duration > 0) {
          let lastContentTime = new Date(date).getTime();
          let minutesSinceLastContent = (currentTime - lastContentTime) / (1000 * 60);
          
          if (minutesSinceLastContent >= duration) 
            continue;
        }
  
        groupIds.push(userChats[i].id);
      }
      if(groupIds.length > 0) 
        params.ids = groupIds;
      else 
        params.group = false;
    }

    if(!params.direct && !params.group) 
      return;

    let response = await Server.chat.getChatDates(params);
    if(!response.success)
      return;

    let chats = response.chats;

    let chatsUpdated = false;
    let newChats = false;

    for(let i = 0; i < chats.length; i++) {
      let chat = chats[i];
      if(chat.date != this.state.lastContent.chats[chat.id]) {
        chatsUpdated = true;
        this.state.lastContent.chats[chat.id] = chat.date;
        window.sessionStorage.removeItem(`ChatRefresh#${chat.id}`);

        if(chat.date != this.state.lastRead.chats[chat.id]) 
          newChats = true;
      }
    }

    if(chatsUpdated)
      this.notifyListeners('chat-dates-updated');

    if(newChats)
      sendDeviceNotification('There are new chat messages!', 'DeviceNotificationsDirect');
  }

  public async setChatLastRead(id: string, date: string, force: boolean = false) {
    let lastReadCookie = Server.user.getCookie('ChatLastRead-' + id);
    if(lastReadCookie && date <= lastReadCookie && !force)
      return;
    await Server.user.setCookie({key: 'ChatLastRead-' + id, value: date});
    this.state.lastRead.chats[id] = date;
    this.notifyListeners('chat-dates-updated');
  }

  public clearChatLastRead(id: string) {
    Server.user.deleteCookie({key: 'ChatLastRead-' + id});
    delete this.state.lastRead.chats[id];
    this.notifyListeners('chat-dates-updated');
  }

  public clearChatContent(id: string) {
    delete this.state.lastContent.chats[id];
    this.notifyListeners('chat-dates-updated');
  }

  public getChatLastRead(id: string) {
    return this.state ? this.state.lastRead.chats[id] : null;
  }

  public isNewChat(currentChat:string = null) {
    if(!this.state)
      return false;

    let userChats = Server.user.getChats();
    for(let i = 0; i < userChats.length; i++) 
      if(this.isNewChatMessages(userChats[i].id)) 
        if(!currentChat || (currentChat && currentChat != userChats[i].id))
          return true;

    let keys = Object.keys(this.state.lastContent.chats);

    for(let i = 0; i < keys.length; i++) 
      if(!userChats.find((c:any) => c.id == keys[i])) 
        if(!currentChat || (currentChat && currentChat != keys[i]))
          return true;

    return false;
  }

  public isNewChatMessages(id:string) {
    if(!this.state)
      return false;

    let lastContent = this.state.lastContent.chats[id];
    let lastRead = this.state.lastRead.chats[id];

    if(!lastContent && lastRead)
      return false;

    if(!lastContent || !lastRead)
      return true;

    return lastContent > lastRead; 
  }

  public onNetworkChatMessage(event:any) {
    this.notifyListeners('chat-message-added', {id: event.chat, date: event.date, message: event.message, user: event.user});

    this.state.lastContent.chats[event.chat] = event.date;
    window.sessionStorage.removeItem(`ChatRefresh#${event.chat}`);

    this.notifyListeners('chat-dates-updated');

    this.sendChatDeviceNotification(event.user);
  }

  public onNetworkChatStarted(event:any) {
    let chat:any = {
      id: event.chat,
      type: event.type
    };

    if(event.type == 'direct')
      chat = {...chat, user: event.user};
    else if(event.type == 'group')
      chat = {...chat, name: event.name};

    Server.user.startChat(chat);

    window.sessionStorage.removeItem(`ChatsRefresh`);

    this.notifyListeners('chat-started');
  }

  protected async sendChatDeviceNotification(userId:string) {
    await Server.public.loadProfiles([userId]);
    let profile = Server.public.getProfile(userId);
    sendDeviceNotification(profile.name + ' sent you a message.', 'DeviceNotificationsDirect')
  }
}